import { ProductDetails } from './ProductDetails';
import { useDataStore } from '@/app/core/components/step-wizard';
import { ContainerInputProps } from '@/app/features/products/common/components/input-props';
import { ClientAttributesSelector } from '@/app/core/components/client-attributes';
import { productDetailsValidator } from '@ssar-app/domain';
import { useEffect, useState } from 'react';

export const ProductDetailsContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();

  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);
  return (
    <>
      {subCode !== '' && (
        <ClientAttributesSelector
          subscriberCodes={[subCode]}
          canSearchAndSelect={false}
          onSuccess={() => {
            // do nothing
          }}
          shouldReturnNode={true}
          onClientAttributesInfoAvailable={({
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            subscriberCode,
            clientAttributes,
          }) => {
            return (
              <ProductDetails
                stepKey={keys}
                moduleProps={{
                  contactType: 'Client',
                  clientAttributes: clientAttributes,
                }}
                validator={productDetailsValidator}
              />
            );
          }}
        />
      )}
    </>
  );
};
